import Api from "./Api";

const endpoint = "/fibu/group";
export default {
    get(params) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        return Api.fetchData(endpoint, usedParams);
    },
    getSingle(id, params) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        return Api.fetchData(endpoint + "/" + id, usedParams);
    },
    getRelatedCategoryIds(id) {
        return Api.fetchData(endpoint + '/related/' + id);
    },
    put(id, data) {
        return Api.putData(endpoint + "/" + id, data);
    },
    post(data) {
        return Api.postData(endpoint, data);
    },
    delete(id) {
        return Api.deleteData(endpoint + "/" + id);
    }
};
